import React, { FunctionComponent } from 'react'
//import styles from './TypeElement.module.sass'
import { ObjectType } from '../../../../responses/objects'
import { Checkbox } from '../../../controls/Checkbox/Checkbox'

interface Props {
    className?: string,
    type: ObjectType,
    checked?: boolean,
    disabled?: boolean,
    onClick?: (checked?: boolean) => void,
}

const TypeElement: FunctionComponent<Props> = props => <Checkbox
    disabled={props.disabled}
    className={props.className}
    value={props.checked}
    onChange={props.onClick}
>
    {/*<div>
        <div className={styles.name}>{props.type.name}</div>
        <div className={styles.info}>
            {props.type.cost && <span>{props.type.cost}₽</span>}
            {props.type.cost && props.type.date_range && <span>&nbsp;|&nbsp;</span>}
            <span>{props.type.date_range}</span>
        </div>
    </div>*/}
</Checkbox>

export default TypeElement